export default "__VITE_ASSET__D6hiFy8M__"